import { updateContactIsResolved, useContact } from "@/api/services/admin/contact";
import { CardContainer } from "@/components/commons/CardContainer";
import { FooterActionBar } from "@/components/commons/FooterActionBar";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { CONTACT_STATUS, CONTACT_STATUS_LABEL } from "@/constants/enum";
import { ContactInfo } from "@/features/contact/components/ContactInfo";
import { AppRoutes } from "@/routes/config";
import { showError } from "@/utils/error";
import { isNumber } from "@/utils/number";
import { useContactListSessionStorage } from "@/hooks/useContactListSessionStorage";
import { Stack, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { toast } from "@/utils/toast";

type TContactDetailPageProps = {};

export const ContactDetailPage: FC<TContactDetailPageProps> = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { data, isLoading, isError } = useContact();
  const { getBackUrl } = useContactListSessionStorage();

  const [isResolvedStatus, setIssResolvedStatus] = useState<boolean>(data?.data.isResolved ?? false);
  const [isStatusUpdatingLoading, setIsStatusUpdatingLoading] = useState<boolean>(false);
  const { id } = useParams();

  useEffect(() => {
    if (!id || !isNumber(id)) {
      const isResolved = pathname.includes("/resolved");
      navigate(isResolved ? AppRoutes.resolvedContact : AppRoutes.unresolvedContact, { replace: true });
    }
  }, [id, pathname, navigate]);

  useEffect(() => {
    if (id && isNumber(id) && !isLoading && (isError || !data?.data)) {
      const isResolved = pathname.includes("/resolved");
      navigate(isResolved ? AppRoutes.resolvedContact : AppRoutes.unresolvedContact, { replace: true });
    }
  }, [id, isLoading, isError, data, pathname, navigate]);

  const backUrl = getBackUrl();

  const handleUpdateContactStatus = async () => {
    setIsStatusUpdatingLoading(true);
    try {
      await updateContactIsResolved(Number(id));
      toast.success(API_SUCCESS_MESSAGE);
      setIssResolvedStatus(true);
    } catch (error) {
      showError(error);
    } finally {
      setIsStatusUpdatingLoading(false);
    }
  };

  return (
    <>
      <CardContainer mb={10}>
        <Stack gap={2}>
          <Typography variant="head20Bold">お問い合わせフォーム</Typography>
          <ContactInfo isLoading={isLoading} data={data} />
        </Stack>
      </CardContainer>
      <FooterActionBar
        title={
          isStatusUpdatingLoading
            ? "作成中…"
            : data?.data.isResolved || isResolvedStatus
              ? CONTACT_STATUS_LABEL[CONTACT_STATUS.RESOLVED]
              : "返信済みとしてマーク"
        }
        onSubmit={handleUpdateContactStatus}
        backUrl={backUrl}
        isDisabled={isStatusUpdatingLoading || data?.data.isResolved || isResolvedStatus}
      />
    </>
  );
};
